import { render, staticRenderFns } from "./EjscLegalAssistant.vue?vue&type=template&id=2610ef66&scoped=true&"
import script from "./EjscLegalAssistant.vue?vue&type=script&lang=js&"
export * from "./EjscLegalAssistant.vue?vue&type=script&lang=js&"
import style0 from "./EjscLegalAssistant.vue?vue&type=style&index=0&id=2610ef66&scoped=true&lang=css&"
import style1 from "./EjscLegalAssistant.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610ef66",
  null
  
)

export default component.exports